
export const DOENLOAD_PREPARING = 0; // 下载准备中
export const DOWNLOAD_ING = 1; // 下载
export const DOWNLOAD_FINISHED = 3; // 下载完成
export const DOWNLOAD_FAILED = 4; // 下载失败

export const INSTALL_ING = 5; // 正在安装 V5.5新增

export const INSTALL_FINISHED = 6; // 安装完成
export const INSTALL_FAILED = 7; // 安装失败
export const DOWNLOAD_CANCELED = 8; // 安装取消

export const ALL_STATUS = [
  DOENLOAD_PREPARING,
  DOWNLOAD_ING,
  DOWNLOAD_FINISHED,
  DOWNLOAD_FAILED,
  INSTALL_FINISHED,
  INSTALL_FAILED,
  DOWNLOAD_CANCELED,
]
